import { isPublicSalesAppPath } from "../lib/surface";
import type { Surface } from "./attribution";

/**
 * Which funnel this page belongs to (POC-538).
 *
 * `apps/frontend` serves TWO audiences from one bundle: the creator dashboard
 * on `app.*`, and every creator storefront on `<creator>.*` (plus custom
 * domains). Tagged on every analytics session so the two funnels can be
 * split without enumerating creator subdomains.
 */
export const resolveSurface = (
	hostname: string,
	pathname = typeof window !== "undefined" ? window.location.pathname : "",
): Surface => {
	if (hostname === "localhost" || hostname === "127.0.0.1") return "app";
	const subdomain = hostname.split(".")[0];
	const isApp =
		subdomain === "app" &&
		(hostname.includes("pocketsflow.com") || // pragma: allowlist secret
			hostname.includes("pocketsflow-test.com")); // pragma: allowlist secret
	// Buyer routes that share the app origin — /checkout, /prod/:id,
	// /u/:id, /credits/:id — are the storefront surface. Same
	// classification the router uses (`isPublicSalesAppPath`).
	if (isApp && isPublicSalesAppPath(pathname)) return "storefront";
	return isApp ? "app" : "storefront";
};

export const resolveStorefrontSlug = (
	hostname: string,
	surface: Surface,
): string => (surface === "storefront" ? hostname.split(".")[0] : "");
